const phoneNumberFormatted = (value) => value.replace(/[+ ]/g, '');

const validatorHelper = {
  phoneNumberFormatted,
};
export default validatorHelper;
